import { USER_ROLE } from '@/config/constants';

export type AuthNavigationOptions = {
  onboardingCompleted?: boolean | null;
};

/** Set by AuthenticateGuard when an unauthenticated visit to a protected route bounces here. */
function consumeReturnTo(): string | null {
  try {
    const value = sessionStorage.getItem('returnTo');
    if (value) sessionStorage.removeItem('returnTo');
    return value;
  } catch {
    return null;
  }
}

/** Post-auth landing paths by role (Wave 1 IA). */
export function pathForRole(
  role: USER_ROLE | string,
  userId?: string,
  options?: AuthNavigationOptions
): string {
  switch (role) {
    case USER_ROLE.ADMIN:
    case 'admin':
      return '/admin/loan-pipeline';
    case USER_ROLE.SELLER:
    case 'seller':
      return userId ? `/seller/main/${userId}` : '/';
    case USER_ROLE.SELLER_AGENT:
    case 'seller_agent': // legacy spelling
      return userId ? `/agent/qualified-contract/${userId}` : '/';
    case USER_ROLE.BUYER:
    case USER_ROLE.USER:
    case 'buyer':
    case 'user':
    default: {
      if (options?.onboardingCompleted === false) {
        return '/onboarding';
      }
      // A deep link that bounced through the auth guard takes priority over
      // the default landing path — don't lose the user's original destination.
      const returnTo = consumeReturnTo();
      if (returnTo && returnTo !== '/') return returnTo;
      return '/properties';
    }
  }
}

/** Full-page navigate after sign-in / role resolution. */
export function navigateByRole(
  role: USER_ROLE | string,
  userId?: string,
  options?: AuthNavigationOptions
): void {
  window.location.href = pathForRole(role, userId, options);
}

/** @deprecated Use navigateByRole — kept name for call-site clarity during signup. */
export const AuthNavigation = navigateByRole;
